import { render, staticRenderFns } from "./domesticDetail.vue?vue&type=template&id=d18f64b2&scoped=true&"
import script from "./domesticDetail.vue?vue&type=script&lang=js&"
export * from "./domesticDetail.vue?vue&type=script&lang=js&"
import style0 from "./domesticDetail.vue?vue&type=style&index=0&id=d18f64b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18f64b2",
  null
  
)

export default component.exports